import { render, staticRenderFns } from "./NeoparentNotifications.vue?vue&type=template&id=28512801&scoped=true"
import script from "./NeoparentNotifications.vue?vue&type=script&lang=js"
export * from "./NeoparentNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28512801",
  null
  
)

export default component.exports